import React, { useCallback, useEffect, useState } from 'react';
import {BsArrowLeft, BsArrowRight} from "react-icons/bs"
import styles from './Kalender.module.css'
import Event from './Event.js';
import calendarImage from '../images/Top_Kalender.jpg';
import LoadingScreen from '../components/LoadingScreen.js';


const Kalender = () => {
    const calendarId = process.env.REACT_APP_CALENDAR_ID;
    const apiKey = process.env.REACT_APP_API_KEY;
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentDate] = useState(new Date());
    const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth()); //Get the current month (0-11, where 0 represents January and 11 represents December)
    const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());
    const monthNames = [ //Array to index the months
        'Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 
        'Juli', 'August', 'September', 'Oktober', 'November', 'December'
    ];
    const [currentMonthName, setCurrentMonthName] = useState("");

    const [prevDate, setPrevDate] = useState('1997-09-24');

    let date=''; // the date to compare with to see if another headline with date is needed in the calendar.
    //A compare function that makes it possible to compare Events, to find there conological order,
      //Since they returns from the api call in the order they were added to the calendar.
    const compare = (x,y) => { 
      let event1 = null;
      let event2 = null;
      
      if(x.start.date){
          event1 = new Date(x.start.date + 'T00:00:00');
          } else if (x.start.dateTime){
              event1 = new Date(x.start.dateTime);
          } else{
              console.log("no time given")
          }
      if(y.start.date){
          event2 = new Date(y.start.date + 'T00:00:00');
          } else if (y.start.dateTime){
              event2 = new Date(y.start.dateTime);
          } else{
              console.log("no time given")
          }
      return event1-event2;
    }
    // gets the events for the given month
    const getEvents = useCallback (async(year, month) => {
        setLoading(true);
        // Calculate the start and end dates of the desired month
        const startDate = new Date(year, month - 1, 1).toISOString();
        const endDate = new Date(year, month, 0, 25, 59, 59).toISOString();
      
        const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?key=${apiKey}&timeMin=${startDate}&timeMax=${endDate}&singleEvents=true`;

        try{
          const response = await fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
        
          if (response.ok) {
            const data = await response.json();
            
            if (data.items.length > 0){
              // console.log(data.items.sort(compare));
              setEvents( data.items.sort(compare))
            } else {
              setEvents([]);
            }
            
          } 
        }catch (error){
          console.error("Fetch error:", error);
        } finally {
        setLoading(false); // End loading
      }
    }, [calendarId, apiKey, compare])

    //Handle when clicking on the next or prev month button.
    const handleBtnClick = (x) => {
    setPrevDate('1997-09-24'); // Reset prevDate
    setCurrentMonth((prevMonth) => {
        let newMonth = prevMonth + x;
        let newYear = currentYear;

        if (newMonth > 11) { // Moving past December
            newYear += 1; // Increment year
            newMonth = 0; // Reset to January
        } else if (newMonth < 0) { // Moving before January
            newYear -= 1; // Decrement year
            newMonth = 11; // Reset to December
        }

        // Update the year and month together
        setCurrentYear(newYear);
        setCurrentMonthName(monthNames[newMonth]);
        // getEvents(newYear, newMonth + 1); // Use the correct newYear and newMonth

        return newMonth;
    });
};
    
      const compareOnlyDate = (x) => {
        if (x.start.date) {
          date = x.start.date;
        } else if (x.start.dateTime) {
          date = x.start.dateTime.split("T")[0]; // Extract date part
        } else {
          console.log("no time given"); 
        }
        if (date > prevDate) {
          return true;
        } else if (date < prevDate) {
          return true;
        } else {
          return false;
        }
      };

    
    useEffect(() => {
        setCurrentMonthName(monthNames[currentMonth]);
        getEvents(currentYear, (currentMonth+1)); //since january is month nr 1 (and so on) we have to increes the currentMonth with one
    }, [currentMonth, currentYear]);

  if (loading) return <LoadingScreen visible={loading}/>;

  return (
    <>
    <LoadingScreen visible={loading}/>
     <image className={styles.backgroundImage} style={{ backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0.00), rgb(251, 246, 217, 0.00)), url(${calendarImage})` }}></image>
        <div className={styles.pageheader}>
          {/* <h3 className={styles.headline}>Kalender</h3> */}
          <div className={styles.calendarNav}>
                  <button className={styles.navBnt} onClick={() => handleBtnClick(-1)}>
                    <BsArrowLeft className={styles.Arrow}/>
                  </button>
                  <h2 className={styles.monthName}>{currentMonthName} {currentYear}</h2>
                  <button className={styles.navBnt} onClick={() => handleBtnClick(1)}>
                    <BsArrowRight className={styles.Arrow}/>
                  </button>
            </div>
        </div>
    <div className={styles.pageContainer}>
        <div className={styles.calendarContainer}>
            
            {loading ? (
                    <h3>Indlæser begivenheder...</h3>
                ) : (
                    <div className={styles.eventList}>
                        {events.length > 0 ? (
                            events.map((event) => (
                                <Event key={event.id} event={event} boolean={compareOnlyDate(event)} />
                            ))
                        ) : (
                            <h3>Ingen begivenheder denne måned</h3>
                        )}
                    </div>
                )}
        </div>
    </div>
    </>
  );
};

export default Kalender;
